// extracted by css-extract-rspack-plugin
export default {"cls1":"HeroThumbnailStack-cls1_3kJ","cls2":"HeroThumbnailStack-cls2_BY2 HeroThumbnailStack-cls1_3kJ","interactive-button":"HeroThumbnailStack-interactive-button_0uO"};